<template>
  <div>
    <!-- <small>{{type.toUpperCase()}}</small> -->
    <!-- <small>{{ Math.round(value) }}</small> -->
    <div class="slider-wrapper">
      <div :class="['slider', type]" :style="{height: `${value}%`}"/>
      <div class="threshold" v-if="threshold > 0" :style="{top: `${100 - threshold}%`}"/>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Thermometer',
  props: {
    value: Number,
    threshold: Number,
    type: String
  }
}
</script>

<style scoped>
small {
  margin-left:-1.25em;
}
.slider-wrapper {
  position: relative;
  width:20px;
  height:45vh;
  background: black;
  background: #342;
  /*box-shadow: 0 0 10px #897;*/
  box-shadow: 0 0 10px #1d2316a8;
}
.slider {
  position: absolute;
  bottom: 0;
  width:100%;
  height:50px;
  transition-property: height;
  transition-duration: 0.5s;
  transition-timing-function: ease-in-out;
}

.ai {
  background: #9999ee;
  box-shadow: 0 0 10px #9999ee;
}

.human {
  background: #99ee99;
  box-shadow: 0 0 10px #99ee99;
}

.threshold {
  border-top: 1px solid red;
  box-shadow: 0 0 3px red;
  height:0px;
  width:100%;
  position: absolute
}
</style>
